module.exports = __webpack_public_path__ + "img/电梯动画3.14c4d788.png";